<template>
    <footer class="app-footer">
        <div class="footer-left">
            <span v-if="backendVersion"> Backend {{ backendVersion }} </span>

            <span v-if="status" class="health-status" :class="status">
                {{ status }}
            </span>
        </div>

        <div class="footer-right">{{ currentYear }} © Performance Matching</div>
    </footer>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import useHealthStore from '@/store/health.store';
import { HealthService } from '@/modules/auth/services/health.service';

const healthStore = useHealthStore();
const { version: backendVersion, status } = storeToRefs(healthStore);

const currentYear = computed(() => new Date().getFullYear());

onMounted(() => {
    new HealthService().loadHealth();
});
</script>

<style scoped lang="scss">
.app-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 16px;
    font-size: 12px;
    background-color: #f5f5f5;
    border-top: 1px solid #ddd;
}

.footer-left {
    display: flex;
    gap: 12px;
    align-items: center;
}

.health-status {
    text-transform: capitalize;
    font-weight: 500;
}

.health-status.healthy {
    color: #2e7d32;
}

.health-status.degraded {
    color: #f9a825;
}

.health-status.unhealthy {
    color: #c62828;
}

.footer-right {
    opacity: 0.6;
}
</style>
